import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle, Package, Shield } from 'lucide-react';

export default function CheckoutSuccess() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const orderNumber = params.get('order');
  const orderId = params.get('id');

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center py-16">
        <div className="w-20 h-20 bg-orange-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle size={40} className="text-orange-500" />
        </div>
        <h1 className="font-bebas text-4xl text-white tracking-wider mb-2">ORDER CONFIRMED</h1>
        {orderNumber && (
          <p className="font-inter text-sm text-zinc-400 mb-6">
            Order <span className="text-orange-400 font-mono font-bold">{orderNumber}</span> has been received.
          </p>
        )}

        <div className="bg-[#1a1a1a] border border-white/10 p-5 text-left mb-6 space-y-3">
          <p className="font-inter text-sm text-white font-semibold">What happens next:</p>
          {[
            { icon: CheckCircle, text: 'Our team will verify your order and FFL dealer information' },
            { icon: Package, text: 'Your suppressor enters the production queue (typically 2–4 weeks)' },
            { icon: Shield, text: 'Serial number assigned and paperwork generated' },
            { icon: Package, text: 'Shipped to your FFL dealer — you complete ATF Form 4 transfer there' },
          ].map((item, i) => {
            const Icon = item.icon;
            return (
              <div key={i} className="flex items-start gap-3">
                <Icon size={14} className="text-orange-500 flex-shrink-0 mt-0.5" />
                <p className="font-inter text-xs text-zinc-400">{item.text}</p>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {orderId && (
            <Link to={`/account/orders/${orderId}`}
              className="flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bebas text-base tracking-widest px-6 py-3 transition-colors">
              TRACK MY ORDER →
            </Link>
          )}
          <Link to="/account"
            className="flex items-center justify-center gap-2 border border-white/20 text-zinc-400 hover:text-white font-bebas text-base tracking-widest px-6 py-3 transition-colors">
            MY ACCOUNT
          </Link>
          <Link to="/shop"
            className="flex items-center justify-center gap-2 border border-white/20 text-zinc-400 hover:text-white font-bebas text-base tracking-widest px-6 py-3 transition-colors">
            CONTINUE SHOPPING
          </Link>
        </div>
      </div>
    </div>
  );
}
